/**
 * Interactive Help Center — flow data types and role metadata.
 */

export interface FlowBranch {
  label: string;
  description: string;
  outcome: string;
}

export interface FlowStep {
  id: string;
  order: number;
  role: string;
  roleName: string;
  action: string;
  description: string;
  screenPath?: string;
  triggerNext: 'auto' | 'manual';
  /** What happens when it's NOT the happy path. */
  branches?: FlowBranch[];
}

export interface FlowDefinition {
  id: string;
  title: string;
  description: string;
  category: 'work-orders' | 'vendors' | 'admin';
  roles: string[];
  steps: FlowStep[];
}

export interface RoleMeta {
  id: string;
  name: string;
  color: string;
  initials: string;
  description: string;
}

export const ROLE_META: Record<string, RoleMeta> = {
  technician:        { id: 'technician',        name: 'Technician',         color: '#3b82f6', initials: 'TC', description: 'Field worker — executes work orders, logs time, reports issues.' },
  supervisor:        { id: 'supervisor',        name: 'Supervisor',         color: '#f59e0b', initials: 'SV', description: 'Team lead — assigns work, approves timecards, reviews reports.' },
  admin:             { id: 'admin',             name: 'Administrator',      color: '#a855f7', initials: 'AD', description: 'System admin — manages users, settings, impersonation.' },
  vendor_tech:       { id: 'vendor_tech',       name: 'Vendor Tech',        color: '#06b6d4', initials: 'VT', description: 'External vendor field worker — receives assignments, updates work status.' },
  vendor_supervisor: { id: 'vendor_supervisor', name: 'Vendor Supervisor',  color: '#0891b2', initials: 'VS', description: 'Vendor team lead — dispatches and reviews their techs.' },
  vendor_admin:      { id: 'vendor_admin',      name: 'Vendor Admin',       color: '#0e7490', initials: 'VA', description: 'Vendor company admin — manages team, compliance docs.' },
};

export const CATEGORY_LABELS: Record<string, string> = {
  'work-orders': 'Work Orders',
  vendors: 'Vendors',
  admin: 'Admin',
};
